import moment from "moment-timezone";
import _ from "lodash";
import CookieUtil from "../../utils/cookieUtil";
import { useEffect, useState } from "react";
import { IMAGES_BASE_PATH } from "../../config/constants";
import jsPDF from 'jspdf';

/**
 * Converts a scheduled time to a formatted local time string based on the event time zone.
 * @param scheduleTime - The event's scheduled time (ISO format or Date object).
 * @param eventZone - The event's time zone (e.g., 'America/New_York').
 * @returns Formatted local time string (e.g., 'MMM D, YYYY h:mm A').
 */
export const localTimeStrFromZone = (scheduleTime: any, eventZone: string): string => {
    return moment.tz(scheduleTime, eventZone).format('MMM D, YYYY h:mm A');
};

export const setShortName = (first_name:any, last_name:any) =>{
    let firstname = first_name?.charAt(0);
    let lastname = last_name?.charAt(0);
    return firstname + lastname;
}

export const getTranslationTitle = (agenda:any) =>{
    let selectedLanguageName    = CookieUtil.readCookie('lang_name');
    return _.get(_.find(agenda.translations, i => i.key === selectedLanguageName), 'title', '')
}
export  const checkDemoTime = (
    start: string,
    end: string,
    showSpeakerView: boolean,
    agenda: any
  ): boolean => {
    const currentDateTime = new Date().getTime();
    const startTime = new Date(start?.replace(/-/g, "/")).getTime();
    const endTime = new Date(end?.replace(/-/g, "/")).getTime();
  
    let allowedTime = new Date(start?.replace(/-/g, "/"));
  
    if (showSpeakerView) {
      return true;
    }
  
    if (agenda.is_restricted && agenda.minutes > 0) {
      allowedTime.setMinutes(allowedTime.getMinutes() - agenda.minutes);
      return currentDateTime >= allowedTime.getTime() && currentDateTime <= endTime;
    }
  
    return true;
};
export const localTimeStr = (schedule_time:any) =>{
    const tzTime = moment(schedule_time).utc().local();
    return tzTime.format('MMMM D, YYYY h:mm A');
}
export const useDetectBrowser = () => {
    const [browser, setBrowser] = useState<string>("unknown");
    const [autoplayMessage, setAutoplayMessage] = useState<boolean>(false);
  
    useEffect(() => {
      const userAgent = navigator.userAgent;
      let detectedBrowser: string;
  
      if (userAgent.includes("Firefox")) detectedBrowser = "Mozilla Firefox";
      else if (userAgent.includes("SamsungBrowser")) detectedBrowser = "Samsung Internet";
      else if (userAgent.includes("OPR") || userAgent.includes("Opera")) detectedBrowser = "Opera";
      else if (userAgent.includes("Trident")) detectedBrowser = "Microsoft Internet Explorer";
      else if (userAgent.includes("Edg")) detectedBrowser = "Microsoft Edge";
      else if (userAgent.includes("Chrome")) detectedBrowser = "Google Chrome or Chromium";
      else if (userAgent.includes("Safari")) {
        detectedBrowser = "Apple Safari";
        setAutoplayMessage(true); // Show autoplay warning for Safari
      } else detectedBrowser = "unknown";
  
      setBrowser(detectedBrowser);
    }, []);
  
    return { browser, autoplayMessage };
};
export const getVideoLink = (agenda:any) =>{
    if (agenda.video) {
        return IMAGES_BASE_PATH + agenda.video.key;
    }

    return null;
}
export const getImage = (imageObject: any) => {
  if (imageObject && imageObject.key) {
      return IMAGES_BASE_PATH + imageObject.key;
  } else if(imageObject) {
      return IMAGES_BASE_PATH + imageObject;
  } else{
      return IMAGES_BASE_PATH + 'default_user/user_profile_image.jpg';
  }
};

export   const downloadCard =  (speaker: any,popUpBackgroundColor:string) => {
    try {
      if (!speaker) return;
      let dummyImage = speaker.salutation=="Mr"?'/images/dummy.jpeg':'/images/dummy_female.png'
 
      const doc = new jsPDF();
      const imageUrl = speaker.profile_picture?.key
      ? IMAGES_BASE_PATH + speaker.profile_picture.key
      : dummyImage;
      
      console.log('Image URL:', imageUrl);

      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = imageUrl;
  
      img.onload = () => {
        doc.setFillColor(popUpBackgroundColor);
        doc.rect(20, 20, 160, 90, 'F'); // 'F' means fill
  
        doc.setFontSize(9);
        doc.rect(20, 20, 160, 90);
        doc.text(`Company: ${speaker.company_name || ''}`, 75, 55);
        doc.text(`${speaker.first_name} ${speaker.last_name}`, 35, 80);
        doc.setFontSize(7);
        doc.text(speaker.job_title || '', 35, 84);
        doc.setFontSize(9);
        doc.text(speaker.Phone || '', 75, 60);
        doc.text(speaker.email || '', 75, 65);
        doc.text(speaker.twitter_profile || '', 75, 70);
        doc.text(speaker.linkedin_profile || '', 75, 75);
        doc.text(speaker.portfolio_link || '', 75, 80);
  
        if (speaker.biography) {
          doc.text(speaker.biography, 75, 90, { maxWidth: 90 });
        }
  
        doc.addImage(img, 'JPEG', 35, 50, 27, 27);
        doc.save(`${speaker.first_name}_${speaker.last_name}.pdf`);
      };
  
      img.onerror = (e) => {
        console.error('Image load error', e);
        doc.save(`${speaker.first_name}_${speaker.last_name}.pdf`);
      };
  
    } catch (error) {
      console.error("Download PDF error:", error);
    }
  };

  export const getVideoThumb=(file:any) =>{
      if(file){
          return file;
      }
  }
  export const getFirstImage = (file:any,slides:any) => {
      if(file && file.key){
          if(slides && slides.length>0){
                return IMAGES_BASE_PATH + slides[0];
          }     

      }
  }

